appSocial.controller('glossaryPage', [
    '$scope', '$state', '$ionicModal', 'SocialLocaleService', 'SocialUtils',
    function ($scope, $state, $ionicModal, SocialLocaleService, SocialUtils) {
        class GlossaryPage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;
                this.$state = $state;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

            }
        }

        return new GlossaryPage()
    }]);

